/**
 * Who is offered a button to open a 1:1 chat with whom.
 *
 * Members who follow each other can always write to each other. A user who
 * holds a badge (Team DS, Nutrizionista DS, Tutor DS…) may write to anyone,
 * followed or not: the badge belongs to the SENDER (client, 21/09/2026). The
 * rule is the same in Contatti, on the profile page and on Mappa.
 *
 * The Dieta Social account stays out of both: nobody gets a chat button
 * towards it, and its "Official" badge doesn't let it write to everyone.
 *
 * This only decides whether the button is shown. Opening the chat still goes
 * through the sender's plan permission (the Guest/FREE popup).
 */

/** `subscription_label` carries the badge instead of the plan when one is set. */
export const hasBadge = (subscriptionLabel) =>
  subscriptionLabel?.type === "badge";

/**
 * The Dieta Social account, by the id the app gets at startup and, for payloads
 * that don't carry it, by name.
 */
export const isDietaSocialAccount = (user, dietaSocialId = null) => {
  if (!user) return false;

  if (user.is_dieta_social === true) return true;

  if (
    dietaSocialId != null &&
    user.id != null &&
    String(user.id) === String(dietaSocialId)
  ) {
    return true;
  }

  return (
    user.subscriber_full_name === "Dieta Social" ||
    (user.name === "Dieta" && user.surname === "Social")
  );
};

export const canStartDirectChat = ({
  isMutual = false,
  viewerCanWriteToAnyone = false,
  targetIsDietaSocial = false,
}) => !targetIsDietaSocial && (!!isMutual || !!viewerCanWriteToAnyone);
